export default "__VITE_ASSET__BJoTMITE__"